import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Fragment } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Input } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import { Editor } from 'slate';
import EditorContext from '../../containers/editor-context';
var AddFormulaDialog = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(AddFormulaDialog, _React$PureComponent);
  var _super = _createSuper(AddFormulaDialog);
  function AddFormulaDialog(props) {
    var _this;
    _classCallCheck(this, AddFormulaDialog);
    _this = _super.call(this, props);
    _this.setInitialValue = function () {
      var editor = EditorContext.getEditor();
      var nodes = Editor.match(editor, editor.selection, {
        type: 'formula'
      });
      if (nodes) {
        var data = nodes[0].data;
        _this.setState({
          formula: data.formula
        });
        _this.formulaNode = nodes;
      }
    };
    _this.handleFormulaChange = function (event) {
      _this.renderFormula(event.target.value);
      _this.setState({
        formula: event.target.value
      });
    };
    _this.renderFormula = function (formula) {
      _this.formulaPreviewer.innerHTML = '';
      var dom = window.MathJax.tex2svg(formula);
      _this.formulaPreviewer.appendChild(dom);
    };
    _this.handleSubmit = function (event) {
      event.preventDefault();
      var formula = _this.state.formula;
      if (_this.formulaNode) {
        _this.editorUtils.setFormula({
          formula: formula,
          at: _this.formulaNode[1]
        });
      } else {
        _this.editorUtils.addFormula({
          formula: formula,
          at: _this.editorSelection
        });
      }
      _this.props.toggleFormulaDialog();
    };
    _this.state = {
      formula: ''
    };
    _this.formulaNode = null;
    _this.editorSelection = null;
    _this.editorUtils = EditorContext.getEditorUtils();
    return _this;
  }
  _createClass(AddFormulaDialog, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.setInitialValue();
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var editor = EditorContext.getEditor();
      this.editorSelection = editor.selection;
      if (this.formulaNode) {
        this.renderFormula(this.state.formula);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      return /*#__PURE__*/React.createElement(Modal, {
        isOpen: true,
        toggle: this.props.toggleFormulaDialog,
        className: this.props.className,
        returnFocusAfterClose: false
      }, /*#__PURE__*/React.createElement(ModalHeader, {
        toggle: this.props.toggleFormulaDialog
      }, this.props.t('insert_formula')), /*#__PURE__*/React.createElement(ModalBody, null, /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "form-group"
      }, /*#__PURE__*/React.createElement("label", {
        className: "form-check-label"
      }, this.props.t('formula')), /*#__PURE__*/React.createElement(Input, {
        type: "textarea",
        className: "form-control",
        value: this.state.formula,
        onChange: this.handleFormulaChange
      })), /*#__PURE__*/React.createElement("div", {
        ref: function ref(_ref) {
          return _this2.formulaPreviewer = _ref;
        },
        className: "formula-preview"
      }))), /*#__PURE__*/React.createElement(ModalFooter, null, /*#__PURE__*/React.createElement(Button, {
        color: "secondary",
        onClick: this.props.toggleFormulaDialog
      }, this.props.t('cancel')), /*#__PURE__*/React.createElement(Button, {
        color: "primary",
        disabled: false,
        onClick: this.handleSubmit
      }, this.props.t('insert_formula'))));
    }
  }]);
  return AddFormulaDialog;
}(React.PureComponent);
export default withTranslation('seafile-editor')(AddFormulaDialog);